import { Label } from "./Label";

export class ColumnProperties {

  id: number;
  FieldLength: number;
  Default: string;
  Maximum: number;
  Minimum: number;
  Labels: Label[];
  PicklistObject: any;
  //picklistObjectId:number;
  FormatType: string;
  FieldType: string;
  MaskingFormat: string;
  Precision: string;
  formats:string;
  Readonly: boolean;
  Nullable: boolean;
  sameasobjectpermission: boolean;
}
